function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon ionic-ios-checkmark-circle",
    d: "M63.375 3.375a60 60 0 1 0 60 60 59.991 59.991 0 0 0-60-60zM94.1 46.788 55.529 85.529H55.5a5.209 5.209 0 0 1-3.346 1.587 5.05 5.05 0 0 1-3.375-1.644L32.625 69.317a1.149 1.149 0 0 1 0-1.644l5.135-5.135a1.115 1.115 0 0 1 1.615 0l12.808 12.808 35.192-35.452a1.139 1.139 0 0 1 .808-.346 1.048 1.048 0 0 1 .808.346l5.048 5.221a1.137 1.137 0 0 1 .061 1.673z",
    transform: "translate(-3.375 -3.375)",
    style: {
      fill: "#07aa3f"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkCircle);
export default __webpack_public_path__ + "static/media/checkmark-circle.ee0870082671b5b9debb48e1e1df3ec4.svg";
export { ForwardRef as ReactComponent };